<template>
  <section class="h-screen font-sans bg-cover">
    <div class="container mx-auto h-full flex flex-1 justify-center items-center">
      <div class="max-w-sm w-96 m-4 py-8 px-10 bg-white rounded shadow-xl ">

        <div class="content">
          <h2 class="mb-4 font-bold text-xl">Choose your workspace</h2>
          <ul>
            <router-link
              tag="li"
              v-for="(site, index) in sites" :key="index"
              :to="{name:'campaigns', params: {site: site.sitekey}}"
              class="py-4 block opacity-50 hover:opacity-100 font-bold hover:pl-2 cursor-pointer transition-all flex justify-between"
              :class="{
                'border-b border-dotted border-gray-400': index !== (sites.length - 1)
            }">
              <span>{{ site.name }} </span>
              <span><font-awesome-icon icon="chevron-right"></font-awesome-icon></span>
            </router-link>
          </ul>
        </div>

        <div class="mt-8 ">
          <common-button
            type="secondary"
            :full-width="true"
            @click="$router.push({name:'WorkspaceCreate'})">Create a workspace</common-button>
        </div>
      </div>

      <h1 class="font-logo text-4xl ml-10"><span class="text-gray-600">Rocket</span><span class="text-primary">fid</span></h1>
    </div>
  </section>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      open: true,
      formCreate: false,
      newSite: {contact: {}}
    }
  },
  computed: {
    ...mapGetters('account', {
      sites: 'sites'
    })
  },
  methods: {
    ...mapActions('account', {
      addSite: 'addSite'
    }),
    createSite () {
      this.newSite.languages = []
      this.newSite.languages.push({ lang: 'fr' })
      this.addSite(this.newSite).then((res) => {
        this.$notify({
          title: 'Success',
          message: this.$root.$t('notifications.site.added'),
          type: 'success'
        })
        this.formCreate = false
        this.newSite = {contact: {}}
      }).catch((response) => {
        this.$notify.error({
          title: this.$root.$t('api.' + response.code + '.title'),
          message: this.$root.$t('api.' + response.code + '.message')
        })
        this.isSaving = false
      })
    }
  },
  mounted () {
    if (this.sites && this.sites.length === 1) {
      this.$router.push({name: 'campaigns', params: {site: this.sites[0].sitekey}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Workspace/WorkspaceList.vue